import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=788cf915"
import script from "./v-button.vue?vue&type=script&lang=js"
export * from "./v-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788cf915')) {
      api.createRecord('788cf915', component.options)
    } else {
      api.reload('788cf915', component.options)
    }
    module.hot.accept("./v-button.vue?vue&type=template&id=788cf915", function () {
      api.rerender('788cf915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/button/v-button.vue"
export default component.exports